import { Type } from 'class-transformer';
import { ValidateNested } from 'class-validator';

export enum AutomationType {
  AUTOMATION_VISUAL_IVR = 'AUTOMATION_VISUAL_IVR',
}

export class Automation {
  id: string;

  @ValidateNested()
  @Type(() => AutomationProvider)
  automationProvider: AutomationProvider;

  @ValidateNested()
  @Type(() => AutomationParameters)
  parameters: AutomationParameters;
}

class AutomationProvider {
  id: string;
  name: string;
  isInternal: boolean;
  type: AutomationType;
  version: number;
  configuration: { visualIvrId: string };
  createdAt: string;
  createdBy: { userId: string; type: string };
  updatedAt: string;
  updatedBy: { userId: string; type: string };
}

class AutomationParameters {
  ivrId: string;
  ivrVersion: number;
}
